/*
 * Global functions - Core page initialization and navigation
 */
/* global global, Gryphon, page_state, mainNav, click_back, click_next, click_skip, shield, shieldRecorded, isDeviceDataInProgress */

import { report } from '../../../services/report';

// Import split modules to register their global.* functions
import './navigation.js';
import './scale.js';
import './shield.js';
import './timers.js';
import './form.js';
import './page.js';
import './device.js';
import './utils.js';

// Mock console.log if it doesn't exist (IE).
if (typeof console === 'undefined') {
  global.console = {
    log: function () {},
  };
}

/*
Disabled due to lack of support on backend
$.ajaxSetup({
  beforeSend: function (xhr) {
    xhr.setRequestHeader('Accepts-Version', window.apiVersion);
  },
});
*/



/**
 * Connects widgets or template to the page based on current page state or API response.
 *
 * @global
 * @function connect_widgets_or_template
 * @param {Object} res - The API response object containing initialization state
 * @param {Object} [res.init_state] - Initial state data from the API
 * @param {Array<Object>} [res.init_state.renderables] - Array of widget configuration objects
 * @param {string} res.init_state.renderables[].question - The question parameter for the widget
 * @param {string} res.init_state.renderables[].view - The view parameter for the widget
 * @param {*} [res.init_state.template] - Template data to load if no widgets are available
 * @returns {void}
 *
 * @description
 * This function binds widget or template loading to the 'after_content_loaded_native' event.
 * It prioritizes widgets over templates when both are available.
 */
global.connect_widgets_or_template = function (res) {
  var renderables = page_state.renderables || res.init_state.renderables;
  var template = page_state.template || res.init_state.template;

  $(page_state).on('after_content_loaded_native', function () {

    (async () => {
      try {
        // Widgets
        if (renderables && renderables.length > 0) {
          // Collect promises for all widgets
          const promises = renderables.filter(e=> e.view !== 'free-text').map(r =>
            Gryphon.load_widget(r.question, r.view)
          );
          await Promise.all(promises); // wait for all widgets
        }

        // Template
        else if (template) {
          await Gryphon.load_template(template);
        }
        set_nav_button_visibility(res);
        Gryphon.events.emit('after_content_loaded');
      } catch (err) {
        const error = err instanceof Error ? err : new Error(String(err));
        error.cause = error.name === 'ChunkLoadError' ? 'lazyLoadingError' : 'customQSLError';
        error.page_name = res.init_state.this_page;

        if (error.cause === 'lazyLoadingError') {
          // Instead of rethrowing the error, we display what is happening since we already throw in the import wrapper
          console.error('Widget loading failed:', error);
        } else {
          console.error(error)
          report.logError(error);
        }

      }

    })();

  });
};

